import React, { useCallback, useMemo } from "react";
import { FormAutocomplete, FormAutocompleteProps } from "@periplus/ui-library";
import { LanguageType } from "i18n";
import { useTranslation } from "react-i18next";
import { EdecCountry } from "../useGetEdecMasterData";

interface Props<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
> extends Omit<
    FormAutocompleteProps<string, Multiple, DisableClearable, FreeSolo>,
    "options"
  > {
  options: EdecCountry[];
}

export default function <
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
>({ options, ...rest }: Props<Multiple, DisableClearable, FreeSolo>) {
  const { i18n } = useTranslation();
  const language = i18n.language as LanguageType;

  const innerOptions = useMemo(
    () => options.map((el) => el.iso_code!),
    [options]
  );

  const getOptionLabel = useCallback(
    (option: string) => {
      const country = options.find((el) => el.iso_code === option)!;
      return `${country.iso_code} - ${country[`name_${language}`]}`;
    },
    [language, options]
  );

  return (
    <FormAutocomplete
      {...rest}
      options={innerOptions}
      getOptionLabel={getOptionLabel}
    />
  );
}
